import script from "./AppendFiltersButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppendFiltersButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppendFiltersButton.vue?vue&type=style&index=0&id=2016c634&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2016c634"]])

export default __exports__